<template>
  <div
    class="contact-opted-out"
    @mouseenter="isHovering = true"
    @mouseleave="isHovering = false"
  >
    <div>{{ $t("outreach_contact_opted_out.badge") }}</div>

    <QIcon
      class="info-icon"
      name="info"
      size="16px"
    />

    <BasePopper v-model="isHovering">
      <div class="contact-opted-out-panel">
        <div
          v-if="outlet.id && route.name !== 'outreach-search-outlet'"
          class="q-pa-md contact-opted-out-outlets"
        >
          <div>
            <span class="">{{ $t("outreach_contact_opted_out.outlets") }}</span>
            <RouterLink
              class="contact-opted-out-outlets-link"
              :to="{
                name: 'outreach-search-outlet',
                params: { id: outlet.id },
              }"
            >
              {{ outlet.name }}
            </RouterLink>
          </div>
        </div>
        <div class="q-pa-md">
          <p>
            {{
              $t("outreach_contact_opted_out.title", {
                platformName: appConfig.platformName,
              })
            }}
          </p>
          <p>
            {{ $t("outreach_contact_opted_out.legal_text") }}
          </p>
          <p>
            {{
              $t("outreach_contact_opted_out.privacy_text", {
                platformName: appConfig.platformName,
              })
            }}
          </p>
        </div>
      </div>
    </BasePopper>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia";
import { ref } from "vue";
import { useRoute } from "vue-router";

import { BasePopper } from "shared/components/base";
import { useGlobalStore } from "shared/stores/global";

interface OutreachContactOptedOutProps {
  outlet: {
    id: number;
    name: string;
  };
}

const isHovering = ref<boolean>(false);

defineProps<OutreachContactOptedOutProps>();

const route = useRoute();

const globalStore = useGlobalStore();
const { appConfig } = storeToRefs(globalStore);
</script>

<style lang="scss" scoped>
.contact-opted-out {
  display: inline-flex;
  align-items: center;
  padding: 2.5px 8px;
  background: rgb(0 0 0 / 8%);
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0.16px;
  border-radius: 16px;
  cursor: text;
  pointer-events: all;
  max-width: fit-content;
  max-height: 24px;

  .q-icon {
    margin-left: 6px;
    color: var(--s-color-denim-7);
  }

  &-panel {
    width: 450px;
    background: #fff;
    border-radius: 4px;
    box-shadow:
      0 1px 3px 0 rgb(0 0 0 / 12%),
      0 1px 1px 0 rgb(0 0 0 / 14%),
      0 2px 1px -1px rgb(0 0 0 / 20%);
    height: 100%;
    margin-top: 6px;
  }

  &-outlets {
    border-bottom: 1px solid var(--s-color-denim-2);
    font-weight: 500;
    font-size: 14px;

    &-link {
      cursor: pointer;
      font-weight: 400;
      color: var(--brand-blue-tertiary, #094791);
    }
  }
}
</style>
